import TrackerForm from 'common/pages/tracker/TrackerForm.tsx'

export const TrackerAdvForm = (props) => <TrackerForm {...props} mode={props.mode} agency={false} />
